import axios from 'axios'

export default {
  namespaced: true,
  state: {
    roles: [],
    rolesAll: [],
    abilities: null,
    pageData: null,
    role: {},
  },
  mutations: {
    listOfRolesUpdate(state, payload) {
      state.roles = payload
    },
    listOfRolesUpdateAll(state, payload) {
      state.rolesAll = payload
    },
    listOfAbilitiesUpdate(state, payload) {
      state.abilities = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setRoleData(state, payload) {
      state.role = payload ? payload : {}
    },
  },
  getters: {
    roleData: (state) => {
      return state.role
    },
    rolesData: (state) => {
      return state.roles
    },
    rolesAllData: (state) => {
      return state.rolesAll
    },
    abilitiesData: (state) => {
      return state.abilities
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    listOfRoles({ commit, rootState }, { limit, page, sort, search }) {
      let url = rootState.apiDomain + '/api/admin/common/role/list?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=role_name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('listOfRolesUpdate', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    listOfRolesAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/common/role/list?limit=0' + '&order[]=role_name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('listOfRolesUpdateAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    listOfAbilities({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/ability/list',
          method: 'GET',
        })
          .then((resp) => {
            commit('listOfAbilitiesUpdate', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    CreateRole({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/role',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    UpdateRole({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/role',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    showRole({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/role/' + id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setRoleData', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onRoleRemove({ rootState }, { id, checkbox }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/role/' + id + '?with_relations=' + checkbox,
          id: id,
          checkbox: checkbox,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    assingRoleToUser({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/role/user-role',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    removeRoleFromUser({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/role/user-role',
          data: data,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
